import { render, staticRenderFns } from "./NavMenuInvitations.vue?vue&type=template&id=d3831870"
import script from "./NavMenuInvitations.vue?vue&type=script&lang=js"
export * from "./NavMenuInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports